
  <div id="registrationtoolselect">
    <dx-data-grid id="gridContainer"
                  [dataSource]="selectedControls"
                  [showBorders]="false"
                  [showColumnHeaders]="true"
                  [wordWrapEnabled]="true"
                  [hoverStateEnabled]="true">
      <dxo-editing mode="cell"
                   [allowUpdating]="true">
      </dxo-editing>
      <dxo-sorting mode="single"></dxo-sorting>

      <dxi-column dataField="description" [allowEditing]="false" sortOrder="asc" caption="Descrizione"></dxi-column>
      <dxi-column dataField="selectedPos" [allowEditing]="true" [width]="100" caption="POS" [setCellValue]="setCellValuePOS"></dxi-column>
      <dxi-column dataField="selectedNeg" [allowEditing]="true" [width]="100" caption="NEG" [setCellValue]="setCellValueNEG"></dxi-column>
      <dxi-column dataField="sortingOrder" [allowEditing]="false" sortOrder="asc" [visible]="false" caption="Ordine"></dxi-column>


      <dxo-selection mode="single"></dxo-selection>
      <dxo-paging [enabled]="false"></dxo-paging>
      <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
      <dxo-group-panel [visible]="false"></dxo-group-panel>
      <dxo-toolbar>
        <dxi-item name="searchPanel" location="before"></dxi-item>
      </dxo-toolbar>
    </dx-data-grid>
  </div>
  <div class="content-block dx-card wide-card responsive-paddings">
    <dx-form id="form"
             labelLocation="left"
             labelMode="floating"
             [formData]="registration"
             [showValidationSummary]="true"
             validationGroup="registrationData">

      <dxi-item dataField="noteControlli"
                editorType="dxTextArea"
                [caption]
                [visible]="true"
                [colSpan]="2">
        <dxo-label text="Note"></dxo-label>
      </dxi-item>
    </dx-form>
  </div>


